export const applyFiltersOnClassificationsReport = (data: Record<string, any>[], filters: Record<string, any>[]) => {
    let filteredData;

    const isUnpricedDisplayed = filters.find(
        (filter: Record<string, any>) => filter.key === 'unpriced_classifications'
    )?.isSelected;
    const isPricedDisplayed = filters.find(
        (filter: Record<string, any>) => filter.key === 'priced_classifications'
    )?.isSelected;

    const isLevel1Displayed = filters.find(
        (filter: Record<string, any>) => filter.key === 'level_1_classifications_display'
    )?.isSelected;
    const isLevel2Displayed = filters.find(
        (filter: Record<string, any>) => filter.key === 'level_2_classifications_display'
    )?.isSelected;
    const isLevel3Displayed = filters.find(
        (filter: Record<string, any>) => filter.key === 'level_3_classifications_display'
    )?.isSelected;

    if ((!isUnpricedDisplayed && !isPricedDisplayed) || (isUnpricedDisplayed && isPricedDisplayed)) {
        filteredData = data;
    } else {
        if (isUnpricedDisplayed) {
            filteredData = data.filter((item: Record<string, any>) => item.totalExclVat === 0);
        }
        if (isPricedDisplayed) {
            filteredData = data.filter((item: Record<string, any>) => item.totalExclVat !== 0);
        }
    }

    return filteredData;
};
